import {
	Box,
	Button,
	Divider,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	Autocomplete,
	TextField,
} from "@mui/material";
import TvIcon from "@mui/icons-material/Tv";
import React from "react";
import { sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import {
	getCustomersByCountry,
	getDurations,
	getQuotaDetailsData,
	setState,
} from "../analyzeSlice";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
	const [countryQD, setCountryQD] = useState("");

	const [alert, setAlert] = useState({
		alertSeverity: "",
		alertDisplay: false,
		alertMessage: ""
	})
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const loginState = useSelector((store) => store.login);
	const {
		countries,
		selectedCountry,
		selectedCountryID,

		selectedAnalysisTypeID,

		customersQD,
		selectedCustomerName,
		selectedCustomerID,

		duration,
		durations,
	} = state;

	const {
		globalSelectedCountryName,
		globalSelectedCountryID,
	} = loginState

	const [selectedCustomerIDs, setSelectedCustomerIDs] = useState("");

	useEffect(() => {
		dispatch(setState("selectedCountry", ""));
		dispatch(setState("selectedCustomerName", ""));
		dispatch(setState("duration", ""));
		dispatch(setState("clearAnalyzeQuotaDetails", false));

		dispatch(setState("customersQD", []));
	}, [])

	let filteredCustomers = customersQD?.filter((value, index, self) => {
	return index === self.findIndex((t) => (
		t.clientCustomerCode === value.clientCustomerCode
	  ))
	});

	useEffect(() => {
		if (countryQD !== "") {
			getCustomersForCountry();
		}
	}, [countryQD]);

	useEffect(() => {
		dispatch(setState("duration", ""));
		if (durations?.length <= 0) {
			dispatch(getDurations());
		}
	}, []);

	function setCountry(event) {
		const name = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === name
		).countryID;

		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));

		setCountryQD(name);

		dispatch(setState("selectedCustomerName", ""));

		dispatch(setState("clearAnalyzeQuotaDetails", false));
	}

	useEffect(() => {
		if (globalSelectedCountryID !== null) {
			dispatch(setState("selectedCountryID", globalSelectedCountryID));
		}
	}, [globalSelectedCountryID])

	useEffect(() => {
		if (globalSelectedCountryName !== null) {
			dispatch(setState("selectedCountry", globalSelectedCountryName));
			setCountryQD(globalSelectedCountryName);
		}
	}, [globalSelectedCountryName])

	function getCustomersForCountry() {
		const obj = {
			countryID: selectedCountryID,
			customerName: selectedCustomerName,
		};
		dispatch(getCustomersByCountry(obj));
	}

	function setCustomer(event, value) {
		console.log(value)
		const name = event.target.value;
		const id = customersQD.find(
			(customer) => customer.customerName === name
		).customerID;

		dispatch(setState("selectedCustomerName", value));
		dispatch(setState("selectedCustomerID", id));
	}

	function setDuration(event) {
		const d = event.target.value;
		dispatch(setState("duration", d));
	}

	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `Please select the ${severityType}`
		});

		setTimeout(() => {
			clearAlert();
		}, [2000])

	}

	const clearAlert = () => {
		setAlert({
			"alertSeverity": "",
			"alertDisplay": false,
			"alertMessage": ``
		});
	}

	const handleCustomerChange = (e) => {
		const value = e.target.value;
		const obj = {
			countryID: selectedCountryID,
			customerName: value,
		};
		dispatch(getCustomersByCountry(obj));

	}

	// useEffect(() => {
	// 	//Check if any of the dropdown are false and then set alertDisplay to false
	// 	const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

	// 	if (isAnyKeyValueFalse(validate)) {
	// 		setAlert({ ...Alert, alertDisplay: false });
	// 	}
	// }, [validate])

	useEffect(() => {
		console.log(selectedCustomerName);
		let selectedCustomersIDList = [];
		let clientCustomerCode = selectedCustomerName?.clientCustomerCode
		let selectedList = customersQD?.filter(item =>item.clientCustomerCode == clientCustomerCode)
		selectedList.forEach((item) => {
			selectedCustomersIDList.push(item.customerID)
		})
		setSelectedCustomerIDs(selectedCustomersIDList.toString());

	},[selectedCustomerName])

	function handleDisplay() {

		if (selectedCountry === null || selectedCountry === "") {
			displayAlert("Country");
			return;
		}
		if (selectedCustomerName === null || selectedCustomerName === "") {
			displayAlert("Customer");
			return;
		}
		if (duration === null || duration === "") {
			displayAlert("Duration");
			return;
		}

		const obj = {
			countryID: selectedCountryID,
			customerID: selectedCustomerIDs,
			duration: duration,
		};

		dispatch(setState("clearAnalyzeQuotaDetails", true));

		dispatch(getQuotaDetailsData(obj));

	}

	return (
		<Box sx={{ mt: 3 }}>
			<Grid container columns={12} spacing={2} justifyContent="flex-start">
				<Grid item sm={6} md={2} >
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							{countries?.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={6} md={3} >

					<Autocomplete
						id="customer-select"
						options={filteredCustomers}
						getOptionLabel={(option) => option ? option.customerName + ' | ' + option.clientCustomerCode : '' }
						value={selectedCustomerName}
						onChange={(event, newValue) => {
							dispatch(setState("selectedCustomerName", newValue));
							//setCustomer(event)
						}}
						renderInput={(params) => (
							<TextField
								{...params ? params : ""}
								onChange={handleCustomerChange}
								label="Customer"
								variant="outlined"
							/>
						)}
					/>
				</Grid>

				<Grid item sm={6} md={2} >
					<FormControl>
						<InputLabel>Duration</InputLabel>
						<Select
							value={duration}
							label="Duration"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setDuration}
						>
							{durations?.map((duration, index) => {
								return (
									<MenuItem key={index} value={duration.value}>
										{duration.value}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={6} md={1} >
					<Button
						startIcon={<TvIcon />}
						sx={{
							bgcolor: "darkred.light",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							"&:hover": {
								bgcolor: "darkred.main",
							},
						}}
						onClick={handleDisplay}
					>
						Display
					</Button>
				</Grid>
			</Grid>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
			<Divider sx={{ mt: 3 }} />
		</Box>
	);
}
